import {Navigate} from "react-router-dom"

export default function RequireStLicence(props) {
    let redirect = props.redirect
    let types = props.types
    if (redirect && types.includes("st") === false) {
        return <Navigate to="/"/>
    } else if (types.includes("st") === false || types === undefined) {
        return ""
    }
    return props.children
}